// extracted by mini-css-extract-plugin
export default {"root":"cross-mixing-content_root__uB4dX","bottomLabel":"cross-mixing-content_bottomLabel__L45d7"};